import { render, staticRenderFns } from "./AreaSelecter.vue?vue&type=template&id=866973a6&"
import script from "./AreaSelecter.vue?vue&type=script&lang=js&"
export * from "./AreaSelecter.vue?vue&type=script&lang=js&"
import style0 from "./AreaSelecter.vue?vue&type=style&index=0&id=866973a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports